import { ApiResponse } from 'apisauce';
import rootReducer from '../store/Reducers';
import Store from '../store/Store';
import Api from './Api';

const store: any = Store({}, rootReducer).getState();

const baseUrl = store.Application.backendURL;

export async function deleteById(
  id: number
): Promise<ApiResponse<unknown, unknown>> {
  const response = await Api.delete(`${baseUrl}extract/delete`, {
    extractId: id,
  });

  return response;
}
